module.exports = __webpack_public_path__ + "static/img/head_2.f4f8113e.png";